import { BaseResource } from "utils/ApiUtils";

class InspectionComment extends BaseResource {
  constructor(args) {
    super(args, InspectionComment.attributes);
  }

  static columns = [
    {
      title: "Project Id",
      field: "ProjectId_WorkItem",
      type: "guid",
      hidden: true,
      hiddenByColumnsButton: true,
    },
    {
      title: "Inspection Comment Id",
      field: "inspectionCommentId",
      type: "guid",
      hidden: true,
      hiddenByColumnsButton: true,
    },
    {
      title: "Ihwi Id",
      field: "ihwiId",
      type: "guid",
      hidden: true,
      hiddenByColumnsButton: true,
    },
    {
      title: "Insp Comm Type Id",
      field: "inspCommTypeId",
      type: "guid",
      hidden: true,
      hiddenByColumnsButton: true,
    },
    {
      title: "Occurence Date",
      field: "occurenceDate",
      type: "date",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      title: "Inspection #",
      field: "InspectionNumber_Inspection",
      type: "string",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    { type: "string", title: "Inspector", field: "Name_SystemUser" },
    {
      title: "Details",
      field: "details",
      type: "string",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      type: "string",
      field: "Description_InspCommType",
      title: "Inspection Comment Type",
    },
  ];

  static attributes = InspectionComment.columns.map((r) => r.field);

  static expand = [
    {
      InspCommType: { select: ["description"] }
    },
    {
      "Ihwi": {
        expand: [
          {
            "WorkItem": {
              select: ["ProjectId"]
            }   
          },
          {
            "Inspection": {
              select: ["InspectionNumber"]
            }
          },
          {
            "Inspection": {
              expand:
              {
                "Rassignment": {
                  expand:
                  {
                    "SystemUser": { "select": ["Name"] }
                  }
                }
              }
            }
          }
        ]
      }
    }
  ];
}

export default InspectionComment;
